// 연습 시간 직접 추가/수정 다이얼로그
import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import Dialog from '../components/AppDialog';
import Stepper from '../metronome/Stepper';

// entry가 있으면 그 기록의 시간을 수정(절대값), 없으면 고른 곡에 시간 추가
export default function TimeDialog({ open, entry, pieceTitle, pieces, onClose, onSubmit }) {
  const [minutes, setMinutes] = useState(30);
  const [pieceId, setPieceId] = useState(0);

  useEffect(() => {
    if (!open) return;
    setMinutes(entry ? Math.max(0, Math.round(entry.seconds / 60)) : 30);
    setPieceId(entry ? entry.piece_id : (pieces[0]?.id || 0));
  }, [open, entry, pieces]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>{entry ? '연습 시간 수정' : '연습 시간 추가'}</DialogTitle>
      <DialogContent>
        {entry ? (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{pieceTitle}</Typography>
        ) : (
          <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', mb: 2 }}>
            {[...pieces, { id: 0, title: '곡 지정 없음' }].map((p) => (
              <Chip
                key={p.id}
                label={p.title}
                onClick={() => setPieceId(p.id)}
                color={pieceId === p.id ? 'primary' : 'default'}
                variant={pieceId === p.id ? 'filled' : 'outlined'}
              />
            ))}
          </Box>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Stepper
            label="연습 시간"
            value={minutes}
            min={entry ? 0 : 5}
            max={600}
            step={5}
            width={72}
            format={(v) => `${v}분`}
            onChange={setMinutes}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button color="inherit" onClick={onClose}>취소</Button>
        <Button variant="contained" onClick={() => onSubmit({ pieceId, minutes })}>저장</Button>
      </DialogActions>
    </Dialog>
  );
}
